// extracted by mini-css-extract-plugin
export default {"filterTutorsPageContainer":"TutorsList_filterTutorsPageContainer__eVqFL","tutorsGrid":"TutorsList_tutorsGrid__3poYB"};